





























import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop({
    default: "https://picbed.qunarzz.com/beb6ee8fa6bbeb397a00be5f4677a382.jpg",
    required: false,
  })
  bgImg!: string;
  @Prop({ default: "bgtype0", required: false })
  type!: string;
  @Prop({ default: false, required: false })
  hasData!: boolean;
}
